(function () {
  var SKIP = '.vl-pdp__form, .vl-routine__form';
  var CART_PATH = /\/cart\/(add|change|update|clear)(\.js|\.json)?\/?$/;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionIds(el) {
    if (el && typeof el.getSectionsToRender === 'function') {
      return el.getSectionsToRender()
        .map(function (s) { return s.id; })
        .join(',');
    }
    return 'cart-drawer,cart-icon-bubble';
  }

  function openDrawer(el, state) {
    if (!el) return;
    el.classList.remove('is-empty');

    if (state && typeof el.renderContents === 'function') {
      el.renderContents(state);
      return;
    }
    if (typeof el.open === 'function') {
      el.open();
      return;
    }
    el.classList.add('active');
  }

  function post(payload, el, btn) {
    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    }

    payload.delete('sections');
    payload.delete('sections_url');
    payload.append('sections', sectionIds(el));
    payload.append('sections_url', window.location.pathname);

    (nativeFetch || window.fetch)((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: payload
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status) {
          console.error('[VitaLume cart] rejected', state);
          return;
        }
        openDrawer(el, state);
        document.dispatchEvent(new CustomEvent('vl:cart:added', { detail: state }));
      })
      .catch(function (err) {
        console.error('[VitaLume cart] failed', err);
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      });
  }

  function hasSections(body) {
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf('sections') !== -1;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
    return false;
  }

  function cartAction(url, method, body) {
    if (!url || String(method || 'GET').toUpperCase() !== 'POST') return null;
    var path;
    try {
      path = new URL(String(url), window.location.origin).pathname;
    } catch (e) {
      return null;
    }
    var match = path.match(CART_PATH);
    if (!match) return null;
    if (hasSections(body)) return null;
    return match[1];
  }

  function withSections(body) {
    var el = drawer();
    if (!el) return body;
    var ids = sectionIds(el);
    var path = window.location.pathname;

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.append('sections', ids);
        body.append('sections_url', path);
        return body;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        body.append('sections', ids);
        body.append('sections_url', path);
        return body;
      }
      if (typeof body === 'string') {
        var trimmed = body.trim();
        if (trimmed.charAt(0) === '{') {
          var data = JSON.parse(trimmed);
          data.sections = ids;
          data.sections_url = path;
          return JSON.stringify(data);
        }
        if (trimmed.indexOf('=') !== -1) {
          return trimmed + '&sections=' + encodeURIComponent(ids) + '&sections_url=' + encodeURIComponent(path);
        }
      }
    } catch (e) {}

    return body;
  }

  function renderSections(el, sections) {
    el.getSectionsToRender().forEach(function (section) {
      var html = sections[section.id];
      if (!html) return;
      var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      var source = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });

    var overlay = el.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', el.close.bind(el));
  }

  function applySections(action, sections) {
    var el = drawer();
    if (!el || !sections) return;

    renderSections(el, sections);

    var empty = !el.querySelector('#CartDrawer .vl-cart__item');
    el.classList.toggle('is-empty', empty);
    var items = el.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', empty);

    if (action === 'add' && !empty && typeof el.open === 'function') el.open();

    document.dispatchEvent(new CustomEvent('vl:cart:added', { detail: { external: true } }));
  }

  function fetchSections(action) {
    var el = drawer();
    if (!el || !nativeFetch) return;

    nativeFetch(shopRoot() + '?sections=' + encodeURIComponent(sectionIds(el)), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (sections) { applySections(action, sections); })
      .catch(function (err) { console.error('[VitaLume cart] sync failed', err); });
  }

  function handleResult(action, data) {
    if (data && data.sections && typeof data.sections === 'object') {
      applySections(action, data.sections);
    } else {
      fetchSections(action);
    }
  }

  if (nativeFetch && !window.__vlCartFetchPatched) {
    window.__vlCartFetchPatched = true;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET';
      var action = cartAction(url, method, init && init.body);

      if (!action) return nativeFetch.apply(window, arguments);

      var injected = !!(init && init.body);
      var nextInit = injected ? Object.assign({}, init, { body: withSections(init.body) }) : init;
      var request = nativeFetch(input, nextInit);

      request
        .then(function (res) {
          if (!res || !res.ok) return;
          if (!injected) return fetchSections(action);
          return res
            .clone()
            .json()
            .then(function (data) { handleResult(action, data); })
            .catch(function () { fetchSections(action); });
        })
        .catch(function () {});

      return request;
    };
  }

  if (typeof XMLHttpRequest !== 'undefined' && !XMLHttpRequest.prototype.__vlCartPatched) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.__vlCartPatched = true;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vlMethod = method;
      this.__vlUrl = url;
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      var action = cartAction(xhr.__vlUrl, xhr.__vlMethod, body);

      if (!action) return xhrSend.apply(this, arguments);

      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        var data = null;
        try {
          data = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText);
        } catch (e) {}
        handleResult(action, data);
      });

      return xhrSend.call(this, body ? withSections(body) : body);
    };
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest ? e.target.closest('a[href*="/cart/add"]') : null;
    if (!link) return;

    var el = drawer();
    if (!el) return;

    var url = new URL(link.href, window.location.origin);
    var id = url.searchParams.get('id');
    if (!id) return;

    e.preventDefault();

    var payload = new FormData();
    payload.append('id', id);
    payload.append('quantity', url.searchParams.get('quantity') || '1');

    var plan = url.searchParams.get('selling_plan');
    if (plan) payload.append('selling_plan', plan);

    post(payload, el, link);
  });

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;

    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.matches(SKIP) || form.closest(SKIP)) return;

    var el = drawer();
    if (!el) return;

    e.preventDefault();
    post(new FormData(form), el, form.querySelector('[type="submit"]'));
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchSections('refresh');
  });
})();